// core.reducer.ts
import { CoreState, coreReducer } from '../core/reducers/core.reducer';
import { FeedState, feedReducer } from '../core/reducers/feed.reducer';
import { FormState, formReducer } from '../core/reducers/form.reducer';
import { HomeState, homeReducer } from '../core/reducers/home.reducer';
import {
  MainMenuState,
  mainMenuReducer,
} from '../core/reducers/main-menu.reducer';
import { ObjectState, objectReducer } from '../core/reducers/object.reducer';
import { PostState, postReducer } from '../core/reducers/post.reducer';
import {
  SelectedObjectsState,
  selectedObjectsReducer,
} from '../core/reducers/selected.reducer';
// auth.reducer.ts
import { UserState, userReducer } from '../core/reducers/auth.reducer';
import { WidgetState, widgetReducer } from '../core/reducers/widget.reducer';
import {
  WorkspaceState,
  workspaceReducer,
} from '../core/reducers/workspace.reducer';

import { ActionReducerMap } from '@ngrx/store';
import {
  principalReducer,
  PrincipalState,
} from '../core/reducers/principals.reducer';

export interface AppState {
  user: UserState;
  core: CoreState;
  feed: FeedState;
  widget: WidgetState;
  object: ObjectState;
  post: PostState;
  workspace: WorkspaceState;
  home: HomeState;
  selected: SelectedObjectsState;
  mainMenu: MainMenuState;
  form: FormState;
  principals: PrincipalState;
}

export const reducers: ActionReducerMap<AppState> = {
  user: userReducer,
  core: coreReducer,
  feed: feedReducer,
  widget: widgetReducer,
  object: objectReducer,
  post: postReducer,
  workspace: workspaceReducer,
  home: homeReducer,
  selected: selectedObjectsReducer,
  mainMenu: mainMenuReducer,
  form: formReducer,
  principals: principalReducer,
};
